import SectionHeader  from "../components/SectionHeader";
import TextWrapper from "./TextWrapper";
import VariantWrapper from "./VariantWrapper";
import ServiceHubPosterChapterData from '../PosterChapter.interface';

export default function LayoutVariant3(props: ServiceHubPosterChapterData) {
    const { subtitle, is_show_date } = props;

    return (
        <VariantWrapper data={props}>
            <TextWrapper style={{ color: 'white' }}>
                <SectionHeader title={subtitle} isShowDate={is_show_date} animated animationOffset={1} />
            </TextWrapper>
        </VariantWrapper>
    )
}
